import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW2900Component } from './kymw2900.component';
import { SharedModule } from '../../../shared/shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { RegistPlanGoodsInfoService } from './api-services/regist-plan-goods-info-service';
import { UpdateProductionCenterCommentService } from './api-services/update-production-center-comment-service';

/**
 * 農産フロント連携画面　モジュール設定クラス
 *
 * @export KYMW2900Module
 * @class KYMW2900Module
 */
@NgModule({
  imports: [
    CommonModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    FormsModule,
  ],
  declarations: [
    KYMW2900Component,
  ],
  providers: [
    RegistPlanGoodsInfoService,
    UpdateProductionCenterCommentService,
  ],
})

export class KYMW2900Module { }
